<!-- <button class="btn btn-danger position-absolute start-50 top-50" style="z-index: 10;" (click)="back()">BACK</button>-->
<router-outlet></router-outlet>
<app-confirm-dialog></app-confirm-dialog>
<app-toast-notifications></app-toast-notifications>
<app-error-modal></app-error-modal>